<template>
  <div class="PaB-accordion" :class="{'is-open': isOpen}">
    <h3 class="PaB-accordion__summary" @click="toggle">
      {{ title }}
      <icon-base icon-name="close" v-if="isOpen" width="20" height="20">
        <icon-angle-up />
      </icon-base>
      <icon-base icon-name="open" v-else width="20" height="20">
        <icon-angle-down />
      </icon-base>
    </h3>
    <div class="PaB-accordion__content" :style="{maxHeight: maxHeight, height: height}" v-if="isOpen">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.PaB-accordion {
  border: 1px solid rgba(#7f7f7f, 0.5);
  border-radius: 3px;
  background-color: #fff;
}

.PaB-accordion__summary {
  cursor: pointer;
  font-size: 16px;
  font-weight: normal;
  padding: 10px;
  min-width: 200px;
  position: relative;
  margin: 0;

  .PaB-accordion.is-open & {
    border-bottom: 1px solid rgba(#7f7f7f, 0.5);
  }

  svg {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.PaB-accordion__content {
  background-color: rgba(#fff, 0.1);
  padding: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>

<script>
import IconBase from '@/components/IconBase'
import IconAngleUp from '@/components/icons/IconAngleUp'
import IconAngleDown from '@/components/icons/IconAngleDown'

export default {
  props: {
    title: String,
    defaultOpen: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: 'none'
    },
    height: {
      type: String,
      default: 'auto'
    }
  },

  components: {
    IconBase,
    IconAngleUp,
    IconAngleDown
  },

  data: function () {
    return {
      isOpen: false
    }
  },

  methods: {
    toggle: function () {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    open: function () {
      this.isOpen = true
      this.$emit('open')
    },
    close: function () {
      this.isOpen = false
      this.$emit('close')
    }
  }
}
</script>
